import React     from 'react';
import useStyles from './tableContainerStyles';

import Paper      from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';


export default function TableContainer(props) {

  const { classes } = useStyles();

  if (!props.title) {
    return props.children;
  }

  return (
    <Paper elevation={3} className={classes.paper}>
      <Typography variant='h6' className={classes.title}>
        {props.title}
      </Typography>
      {props.children}
    </Paper>
  );
}

TableContainer.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
};
